import { BackSide, CylinderGeometry, Mesh, MeshBasicMaterial, Object3D } from 'three'
import C from '../lib/Constants'

export default class Sky
{
    constructor(_options)
    {
        this.time = _options.time
        this.materials = _options.materials

        this.container = new Object3D()
        this.container.name = 'sky_container'

        this.setInstance()
    }

    setInstance()
    {
        // Set geometry
        let maxSize = Math.max(Math.abs(C.SCENE.minBoundary.x), Math.abs(C.SCENE.minBoundary.z), Math.abs(C.SCENE.maxBoundary.x), Math.abs(C.SCENE.maxBoundary.z))
        maxSize += 2
        const height = 2
        const geo = new CylinderGeometry(maxSize, maxSize, height, 32, 1, true)

        // Adjust texture
        this.materials.items.skyMat.map.repeat.set(3, 1)

        // Set mesh
        const mesh = new Mesh(geo, this.materials.items.skyMat)
        mesh.position.y = height * 0.35
        mesh.renderOrder = -4

        this.instance = mesh
        this.container.add(this.instance)

        // Set rotation
        this.time.on('tick', () =>
        {
            this.instance.rotation.y += 0.0001
        })
    }
}